module.exports = __webpack_public_path__ + "img/img_nav_bank-w.805a2e60.svg";